export default __webpack_public_path__ + "static/media/batata_doceUruguaia.ea18392c.jpg";